import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Business } from '../models/business';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { IBusinessDetails } from '../../assessment-app/data/business-details';
import { Observable } from 'rxjs';
import { DataProtection } from '../../assessment-app/data/data-protection';
import { FeedbackDetails } from '../../assessment-app/data/feedback-details';
import { IFeedbackQuestions } from '../../assessment-app/data/feedback-questions';
import { SubdomainInfo } from '../models/subdomain-info';

@Injectable({
  providedIn: 'root'
})
export class BusinessService extends BaseApiService<Business> {

  constructor(httpClient: HttpClient) {
    super(httpClient, `${environment.apiUrl}/Businesses`);
  }

  GetInitialAssessmentBusinessDetails(): Observable<IBusinessDetails> {
    return this.httpClient.get<IBusinessDetails>(`${environment.apiUrl}/businesses/InitialAssessmentBusinessDetails`);
  }
  ValidateSubdomain() {
      const url = this.baseApiUrl + '/ValidateSubdomain';
      let test = this.httpClient.get<SubdomainInfo>(url);
      return test;
    }
  
  getDeclarations(): Observable<DataProtection> {
    return this.httpClient.get<DataProtection>(`${environment.apiUrl}/businesses/GetInitialAssessmentDeclarations`);
}

  getFeedback(): Observable<IFeedbackQuestions> {
    return this.httpClient.get<IFeedbackQuestions>(`${environment.apiUrl}/businesses/GetInitialAssessmentFeedbackQuestion`);
  }

}
